import { Affix, AutoComplete, Divider, Form, Input, PageHeader } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { ArrowLeftIcon } from 'components/Icons';
import { RevxButton } from 'components/RevxButton';
import { RevxSpin } from 'components/RevxSpin';
import { Headline } from 'components/RevxTypography';
import { ResellerCertificate } from 'domains/resellerCertificateDomain';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import states from 'states-us';
import {
  ADMIN_DETAIL_AFFIX_TOP,
  PLATFORM_FORM_ITEM_LAYOUT,
} from 'utils/constants';

export const ResellerCertificateForm = () => {
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const saving = useAppSelector(
    (state) =>
      state.loading.effects.resellerCertificate.updateResellerCertificate
  );

  const item = useAppSelector((state) => state.resellerCertificate.curItem);

  useEffect(() => {
    form.setFieldsValue({
      ...item,
      state: `${states.find((s) => s.abbreviation === item?.state)?.name} (${
        states.find((s) => s.abbreviation === item?.state)?.abbreviation
      })`,
    });
  }, [item, form]);

  const onClose = () => {
    dispatch.resellerCertificate.setState({ curItem: undefined });
  };

  const onSave = async () => {
    let values: Partial<ResellerCertificate>;
    try {
      values = await form.validateFields();
      values.certificateId = (values.certificateId + '')?.trim();

      await dispatch.resellerCertificate.updateResellerCertificate({
        ...item,
        ...values,
        state: item?.state,
      });
      dispatch.resellerCertificate.getPage();

      onClose();
    } catch (validationError) {
      // do nothing when form invalid
      return;
    }
  };

  const actionBar = (
    <div>
      <Affix offsetTop={ADMIN_DETAIL_AFFIX_TOP}>
        <PageHeader
          className="platform-item-form-header"
          onBack={() => {
            onClose();
          }}
          backIcon={<ArrowLeftIcon />}
          title={
            <Headline>
              {item?.id
                ? t('platform.resellerCertificate.form.title.edit')
                : t('platform.resellerCertificate.form.title.create')}
            </Headline>
          }
          extra={[
            <RevxButton type="primary" brandGreen onClick={onSave} key="save">
              {t('common.save')}
            </RevxButton>,
            <>
              <Divider type="vertical" />
              <RevxButton onClick={onClose} brandGreen key="cancel">
                {t('common.cancel')}
              </RevxButton>
            </>,
          ]}
        ></PageHeader>
      </Affix>
    </div>
  );
  return (
    <>
      <RevxSpin spinning={saving}>
        {actionBar}
        <div className="platform-item-form-wrapper">
          <Form
            {...PLATFORM_FORM_ITEM_LAYOUT}
            layout={'horizontal'}
            form={form}
            className="platform-item-form"
            // onValuesChange={onValuesChange}
            initialValues={{
              ...item,
            }}
          >
            <Form.Item name="state" label={t('common.state')}>
              <AutoComplete disabled>
                {states.map((s) => (
                  <AutoComplete.Option value={s.name} key={s.name}>
                    {s.name}
                  </AutoComplete.Option>
                ))}
              </AutoComplete>
            </Form.Item>

            <Form.Item
              label={t(
                'platform.resellerCertificate.columnTitle.certificateId'
              )}
              name="certificateId"
              rules={[{ required: true }]}
            >
              <Input maxLength={255} />
            </Form.Item>
          </Form>
        </div>
      </RevxSpin>
    </>
  );
};
